export default function (getImportList, $stateParams) {
    const vm = this;

    vm.fetchingRecords = true;
    vm.errorsOccurred = false;
    vm.queryStringToken = localStorage.getItem('token');
    vm.records = [];
    vm.hasMoreData = true;
    vm.pageNumber = 1;
    vm.exportId = $stateParams.exportId;

    vm.canGoToPreviousPage = canGoToPreviousPage;
    vm.loadPreviousPage = loadPreviousPage;
    vm.canGoToNextPage = canGoToNextPage;
    vm.loadNextPage = loadNextPage;

    /* --- */

    requestImportList(1);

    /* --- */

    function requestImportList(pageNumber) {
        vm.pageNumber = pageNumber;
        vm.fetchingRecords = true;

        getImportList(pageNumber, vm.exportId)
            .then(result => {
                if (vm.pageNumber !== pageNumber) {
                    return;
                }

                vm.fetchingRecords = false;
                vm.records = result.data;
                vm.hasMoreData = result.hasMoreData;
            })
            .catch(() => {
                vm.fetchingRecords = false;
                vm.errorsOccurred = true;
            });
    }

    function canGoToPreviousPage() {
        return vm.pageNumber > 1;
    }

    function loadPreviousPage() {
        if (vm.pageNumber === 1) {
            return;
        }
        requestImportList(vm.pageNumber - 1);
    }

    function canGoToNextPage() {
        return vm.hasMoreData;
    }

    function loadNextPage() {
        if (vm.hasMoreData) {
            requestImportList(vm.pageNumber + 1);
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/data-import-export/controllers/import/list/importListCtrl.js